const brandsWithEmptySearchMessage = ['saritur', 'expressosaoluiz'];

/** Returns whether the empty state should offer to clear active filters. */
export default function hasTooManyFilters({
  searchIsPolling,
  noTrips,
  activeFilters,
  brand,
  tripList,
}) {
  return (
    !searchIsPolling &&
    noTrips &&
    activeFilters &&
    (tripList?.size !== 0 || !brandsWithEmptySearchMessage.includes(brand))
  );
}
